<template>
  <validation-provider
    #default="{ errors }"
    name="Durum"
    rules="required"
  >
    <v-select
      id="limits"
      v-model="dataItem.package_limits[iKey].limit"
      label="title"
      :options="statuses"
      :reduce="item => item.id"
      placeholder="Seçiniz"
      :disabled="dataItem.package_limits[iKey].disabled === '1'"
    />
    <small class="text-danger">{{ errors[0] }}</small>
  </validation-provider>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
// eslint-disable-next-line no-unused-vars
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'PackageLimitSelectCard',
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    iKey: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      locale: 'tr',
      statuses: [
        {
          id: '1',
          title: 'Aktif',
        },
        {
          id: '0',
          title: 'Pasif',
        },
      ],
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['projectPackages/dataItem']
    },
  },
  created() {
    localize(this.locale)
  },
}
</script>

<style scoped></style>
